import { useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BaseViewModel from "base/BaseViewModel";
import { CONFIRMATION, FORGOT_PASSWORD, RESET_PASSWORD } from "constants/path";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { DEFAULT_VALUES } from "./constants";
import UserModel from "../../models/userModel";

function useAuth() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();

	const userModel = useContext(UserModel.Context);

	const methods = useForm({
		defaultValues: DEFAULT_VALUES,
		// resolver: useYupValidationResolver(SCHEMA)
	})

	const { setValue } = methods;

	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingVerify, setIsLoadingVerify] = useState(false);

	const onLogin = async () => {
		setIsLoading(true);
		const url = await userModel.login();
		setIsLoading(false);
		if (url) {
			window.location.href = url;
		}
	};

	const onVerify = async (data) => {
		const { Email, otp } = data;
		setIsLoadingVerify(true);
		setTimeout(() => setIsLoadingVerify(false), 5000);
	}

	const onRequestOTP = async (data) => {
		console.log(data);
	}

	const onSendEmail = async (data) => {
		const { Email } = data;
		navigate(RESET_PASSWORD, {
			state: {
				Email
			}
		})
	}

	const onResetPassword = async (data) => {
		navigate(CONFIRMATION);
	}

	useEffect(() => {
		const { pathname, state } = location;
		const { Email, Username, sessionUserAttributes } = state || {};
		if (pathname === FORGOT_PASSWORD) {
			setValue("type", "forgot");
			return;
		}
		if (pathname === RESET_PASSWORD) {
			if (sessionUserAttributes) {
				setValue("sessionUserAttributes", sessionUserAttributes);
				setValue("Username", Username);
			}
			setValue("Email", Email);
			setValue("type", "reset");
			return;
		}
		setValue("type", "login");
	}, [location]);

	return {
		t,
		navigate,
		isLoading,
		isLoadingVerify,
		setIsLoading,
		methods,
		onLogin,
		onVerify,
		onRequestOTP,
		onSendEmail,
		onResetPassword,
	};
}

const AuthViewModel = BaseViewModel(useAuth);

export default AuthViewModel;
